// Generated by ReScript, PLEASE EDIT WITH CARE


let baseRoute = "/promotions";

let createRoute = baseRoute + "/create";

function showRoute(cku) {
  return baseRoute + "/" + cku;
}

function authorizedCreateRoute(authScope) {
  if (authScope.TAG === "Organisation") {
    if (authScope.shops.length < 6) {
      return {
        TAG: "Ok",
        _0: createRoute
      };
    } else {
      return {
        TAG: "Error",
        _0: undefined
      };
    }
  } else if (authScope._0.kind === "WAREHOUSE") {
    return {
      TAG: "Error",
      _0: undefined
    };
  } else {
    return {
      TAG: "Ok",
      _0: createRoute
    };
  }
}

export {
  baseRoute,
  createRoute,
  showRoute,
  authorizedCreateRoute,
}
/* No side effect */
